const REPLY_MARKER = /(wrote\s*:|ha scritto|scritto\s*:|scrisse|napisał|napsal|geschrieben|a écrit|escribió|skrev)/i;
const DATEISH = /\d{1,2}\s*[./-]\s*\d{1,2}\s*[./-]\s*\d{2,4}|\d{4}-\d{1,2}-\d{1,2}|\d{1,2}\s+[a-zà-ž]{3,9}\.?,?\s+\d{1,2},?\s*\d{2,4}|[a-zà-ž]{3,9}\.?\s+\d{1,2},?\s*\d{2,4}|\d{1,2}:\d{2}/i;

export function splitQuotedText(text = '') {
  const value = String(text || '');
  // Explicit mail-client separators are safe even when a MIME text alternative was flattened.
  const separator = /[-_–—]{3,}\s*(?:Rispondi al messaggio|Reply to message|Original Message|Messaggio originale|Forwarded message|Пересылаемое сообщение|Ответ на сообщение)\s*[-_–—]{3,}/i.exec(value);
  if (separator && separator.index > 0 && /(?:Date|Data|From|Da|От|Дата)\s*:/i.test(value.slice(separator.index, separator.index + 500))) return { main: value.slice(0, separator.index).trimEnd(), quoted: value.slice(separator.index) };
  const lines = value.split(/\r?\n/);
  if (lines.length < 3) return null;
  for (let i = 1; i < lines.length - 1; i++) {
    const line = lines[i];
    if (line.length > 220) continue;
    const quotedNext = /^>/.test((lines[i + 1] || '').trimStart());
    const explicitReply = (REPLY_MARKER.test(line) && DATEISH.test(line)) || (/^.{0,60}<[^<>]+@[^<>]+>\s*:/.test(line) && DATEISH.test(line));
    if ((explicitReply || (quotedNext && i >= lines.length / 5)) && lines.slice(0, i).join('').trim()) return { main: lines.slice(0, i).join('\n').trimEnd(), quoted: lines.slice(i).join('\n') };
  }
  return null;
}

export function stripQuotedHistory(text = '') { return splitQuotedText(text)?.main ?? String(text || ''); }

export function splitSignatureText(text = '') {
  const lines = String(text || '').split(/\r?\n/);
  // Some mailbox footers run much longer than a normal personal signature.
  // A long rule followed immediately by the company name is a reliable boundary.
  for (let i = 1; i < lines.length - 2; i++) {
    if (!/^[-_]{8,}$/.test(lines[i].trim())) continue;
    const companyHeader = lines.slice(i + 1, i + 5).some((line) => /^Bottle of Italy(?:\s+S\.?R\.?L\.?)?(?:\s*[-–—]|\s*$)/i.test(line.trim()));
    if (companyHeader && lines.slice(0, i).join('').trim()) {
      return { main: lines.slice(0, i).join('\n').trimEnd(), signature: lines.slice(i).join('\n') };
    }
  }
  for (let i = Math.max(1, lines.length - 14); i < lines.length - 1; i++) {
    const line = lines[i].trim();
    const explicitDelimiter = /^--\s*$/.test(line);
    const closing = /^(?:cordiali saluti|distinti saluti|best regards|kind regards|mit freundlichen grüßen|bien cordialement)[,!.\s]*$/i.test(line);
    const tail = lines.slice(i + 1).join('\n');
    const contact = /(?:[\w.+-]+@[\w.-]+\.[a-z]{2,}|https?:\/\/|www\.|\b(?:tel|phone|telefono|mobile)\s*[:+]|bottle of italy)/i.test(tail);
    if ((explicitDelimiter || (closing && contact)) && lines.slice(0, i).join('').trim() && tail.trim()) return { main: lines.slice(0, i).join('\n').trimEnd(), signature: lines.slice(i).join('\n') };
  }
  return null;
}

export function splitMessageText(text = '') {
  const quote = splitQuotedText(text);
  const signature = splitSignatureText(quote?.main ?? text);
  if (!quote && !signature) return null;
  return {
    main: signature?.main ?? quote?.main ?? String(text || ''),
    hidden: [signature?.signature, quote?.quoted].filter(Boolean).join('\n\n'),
    kind: signature && quote ? 'both' : signature ? 'signature' : 'quote'
  };
}

export function stripMessageTail(text = '') { return splitMessageText(text)?.main ?? String(text || ''); }

export function stripQuotedHtml(html = '') {
  return String(html || '')
    .replace(/<div[^>]+class=["'][^"']*(?:gmail_quote|yahoo_quoted)[^"']*["'][^>]*>[\s\S]*$/i, '')
    .replace(/<blockquote\b[^>]*>[\s\S]*$/i, '');
}

export function stripMessageTailHtml(html = '') {
  return stripQuotedHtml(html).replace(/<(?:div|table|section)[^>]+(?:class=["'][^"']*(?:gmail_signature|email-signature|mail-signature)[^"']*["']|data-smartmail=["']gmail_signature["'])[^>]*>[\s\S]*$/i, '');
}
